import { User } from './User';

export enum BidStatusEnum {
  ACTIVE = 'active',
  COMPLETED = 'completed',
  PLANNED = 'planned',
}

export type Bid = {
  bid_amount: number;
  id: number;
  created_at: string;
  is_refunded: boolean;
  user: User;
};

export type Auction = {
  about: string;
  can_overbid_self: boolean;
  bidders_count: number;
  end_datetime: string;
  id: number;
  images: { image: string }[];
  highest_bid: string;
  only_wallet_owner: boolean;
  number_winners: number;
  start_datetime: string;
  step: number;
  title: string;
  status: BidStatusEnum;
};

export type BidCommonInfo = {
  bidders_count: number;
  highest_bid: string;
};

export type MyBidsResponse = {
  my_bids: Record<number, Bid>;
};

export type MyWonAuctionsResponse = {
  won_auctions: Record<string, boolean>;
};
